import '../../scss/acf-blocks/block-system-requirements.scss';
const changeSrTabMobile = () => {
    const selectElements = document.querySelectorAll('.js-sr-mobile-tabs');
    selectElements.forEach(function (selectElement) {
        selectElement.addEventListener('change', function () {
            const menuElement = document.querySelector(`[data-tab-id =${selectElement.value}]`);
            if (menuElement) {
                menuElement.click();
            }
        });
    });
};
const changeSrTab = (TARGET) => {
    var _a, _b;
    const nav = TARGET.closest('.system-requirements-content-nav');
    nav.querySelectorAll('a').forEach((menuItem) => {
        menuItem.classList.remove('active');
    });
    TARGET.classList.add('active');
    const tabs = TARGET.closest('.os-wrapper').querySelectorAll('.system-requirements-content-tab');
    tabs.forEach((tab) => {
        tab.classList.remove('active');
    });
    if ((_a = TARGET.dataset) === null || _a === void 0 ? void 0 : _a.tabId) {
        (_b = document.getElementById(TARGET.dataset.tabId)) === null || _b === void 0 ? void 0 : _b.classList.add('active');
    }
};
changeSrTabMobile();
export { changeSrTab, changeSrTabMobile };
